import React, { Component } from 'react';
import { Alert, Button } from 'react-bootstrap';

export default class DesignPlacementForm extends Component {
    constructor(props) {
        super(props);
        const value = props.value || {}, crs = value.sourceCrs || {}, fit = value.registration || {};
        const translation = fit.translation || [0, 0];
        this.state = { zone: crs.zone || 56, hemisphere: crs.hemisphere || 'S',
            east: translation[0], north: translation[1], height: fit.verticalOffset || 0,
            rotation: (fit.rotation || 0) * 180 / Math.PI, error: '', saving: false };
    }
    save = async event => {
        event.preventDefault();
        const { zone, hemisphere, east, north, height, rotation } = this.state;
        if ([zone, east, north, height, rotation].some(value => String(value).trim() === '' || !Number.isFinite(Number(value)))
            || !Number.isInteger(Number(zone)) || Number(zone) < 1 || Number(zone) > 60) {
            this.setState({ error: 'Enter a UTM zone from 1 to 60 and finite placement values' }); return;
        }
        this.setState({ saving: true, error: '' });
        try {
            await this.props.onSave({ mode: 'review', sourceCrs: { zone: Number(zone), hemisphere },
                translation: [Number(east), Number(north)], verticalOffset: Number(height), rotationDegrees: Number(rotation) });
        } catch (error) { this.setState({ error: error.message, saving: false }); }
    }
    render() {
        return <form onSubmit={this.save} className="design-registration">
            <h3>Place design for review</h3>
            <p>Zero offsets display the supplied coordinates. Adjust placement as you review; survey points and error tolerance are optional through surveyed registration. Rotation is about the UTM origin, followed by the offsets below.</p>
            {[['zone', 'UTM zone'], ['east', 'Easting offset (m)'], ['north', 'Northing offset (m)'], ['height', 'Height offset (m)'], ['rotation', 'Rotation (degrees)']].map(([key, label]) =>
                <label key={key} style={{ display: 'block' }}>{label} <input aria-label={label} type="number" step="any" value={this.state[key]} onChange={event => this.setState({ [key]: event.target.value })} /></label>)}
            <label>Hemisphere <select aria-label="Hemisphere" value={this.state.hemisphere} onChange={event => this.setState({ hemisphere: event.target.value })}><option value="S">South</option><option value="N">North</option></select></label>
            {this.state.error && <Alert variant="danger">{this.state.error}</Alert>}
            <div className="design-registration-actions"><Button type="button" variant="secondary" onClick={this.props.onCancel}>Cancel</Button> <Button type="submit" disabled={this.state.saving}>Save and show in map</Button></div>
        </form>;
    }
}
